import {
	Report,
	stores,
	Elements,
	utils
} from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { ClientViewStore } from '../stores/ClientViewStore'
import RootStore from '../stores/RootStore'
import $http from '../utils/$http'
import bkflogo from '../media/images/common/BKF-standard-b.png'
import LaunchIcon from '@material-ui/icons/Launch'


const { Heading4, Paragraph, Anchor } = Elements
const { setCookie } = utils

const ReportSummary = ({
	reportStore,
	i18n,
}: {
	reportStore: stores.ReportStore
	i18n: Function,
}) => (

	<>

		{reportStore.depersonalizedOrderInformation === null ?
			<div className={'ReadReportContent__Section hideOnPrint'} id={'Specifications'}>

				<Heading4>{i18n('readreport.label.reportSummary')}</Heading4>
				<Paragraph>

					{reportStore.order.reportSummary || i18n('defaultValue.reportSummary')}
				</Paragraph>
			</div> : <></>
		}

	</>

)

const ReportSummaryForOrderer = ({
	reportStore,
	i18n,
}: {
	reportStore: stores.ReportStore
	i18n: Function
}) => reportStore.order.reportSummaryForOrderer
		? (
			<>
				{
					reportStore.depersonalizedOrderInformation === null ?
					<div className={'ReadReportContent__Section'} id={'Specifications'}>
						<Heading4>{i18n('readreport.label.reportSummaryForOrderer')}</Heading4>
						<Paragraph>
							{reportStore.order.reportSummaryForOrderer}
						</Paragraph>
					</div> : <></>
				}
			</>
		)
		: null;

const InfoSection = ({
	reportStore,
	i18n,
}: {
	reportStore: stores.ReportStore
	i18n: Function
}) => (
	<div className={'ReadReportContent__Section'} id={'Info'}>
		<Heading4>{i18n('readreport.label.customer.importanInfo')}</Heading4>
		<Paragraph className={'ReadReportContent__Space--medium'}>
			{i18n('readreport.info.customer.preamble.row1')}
		</Paragraph>
		<Paragraph className={'ReadReportContent__Space--small'}>
			{i18n('readreport.info.customer.preamble.row2')}
		</Paragraph>
		<Paragraph className={'ReadReportContent__Space--small'}>
			{i18n('readreport.info.customer.preamble.row3')}
		</Paragraph>
		<Paragraph className={'ReadReportContent__Space--small'}>
			{i18n('readreport.info.customer.preamble.row4')}
		</Paragraph>
		<Paragraph className={'ReadReportContent__Space--small'}>
			{i18n('readreport.info.customer.preamble.row5')}
		</Paragraph>
		<Paragraph className={'ReadReportContent__Space--medium'}>
			<Anchor href='/general-terms' target='_blank'>
				{i18n('common.terms-of-delivery')}
				<LaunchIcon
				style={{
					position: 'absolute',
					fontSize: '2.3rem',
					marginLeft: '0.4rem',
					opacity: '0.6'
				}} 
				className='footer-links-launchIcon' 
				fontSize='small' />
			</Anchor>
		</Paragraph>
		<div>
			<img src={bkflogo} style={{float:'right', width: '140px', marginTop: '12px'}}/>
		</div>
	</div>
)

const ReadReportCore = observer(({ closeReport, store }: { closeReport?: () => void, store: ClientViewStore<RootStore> }) => {
	const intl = useIntl()
	const i18n = (id: string) => intl.formatMessage({ id })
	const formatDate = date => (date ? intl.formatDate(date) : '')
	const formatTime = date => (date ? intl.formatTime(date) : '')
	const { rootStore } = store
	const reportStore = store.reportStore

	const { user } = rootStore.userStore

	const getFilesMetaData = (orderId: number) => {
		return $http.get<any>(`/order/filestorage/meta/${orderId}`)
	}
	const getFile = (fileId: number) => {
		return $http.get<any>(`/order/filestorage/${fileId}`, "blob")
	}

	const isOrderer = utils.getUserRoles(user).some(r => r.role === 'Orderer')

	return  (
		<Report.Report
			{...{
				i18n,
				formatDate,
				formatTime,
				reportStore: (reportStore as any),
				InfoSection,
				ReportSummary: isOrderer ? ReportSummaryForOrderer : ReportSummary,
				closeReport,
				getFilesMetaData,
				getFile,
			}}
		/>)
})

export default ReadReportCore
